import React from 'react';
import Chip from './Chip';
import styles from './Chips.module.scss';

type Props = {
    data: Array<{id: string, title: string}>;
    onRemoveItem: (id: string) => void;
}

const ChipsList = ({data, onRemoveItem}: Props) => {
    return <section className={styles.chipsList}>
        {data.map(chipData => {
            return <Chip title={chipData.title} onClose={() => onRemoveItem(chipData.id)}/>
        })}
    </section>
}

export default ChipsList;